/*
AJAXy business to handle cached environment
*/

function onHaveUserData() {
    var data = JSON.parse(sessionStorage.getItem(window.storageKey));

    // show stuff based on logged in status
    if (data.loggedIn) {
        $('.logged-in-show').removeClass('logged-in-show');
    } else {
        $('.logged-out-show').removeClass('logged-out-show');
    }

    // show stuff based on cart count
    $('#cart-count').text(data.cartCount);
    if (data.cartCount === 0) {
        $('.empty-cart-show').removeClass('empty-cart-show');
    } else {
        $('.filled-cart-show').removeClass('filled-cart-show');
    }
}

function fetchUserData() {
    $.ajax({
        method: 'post',
        url: "/wp-admin/admin-ajax.php",
        data: {
            'action': 'sc_get_user_data'
        },
        success: function (sessionData) {
            sessionStorage.setItem(window.storageKey, sessionData);
        },
        complete: function () {
            onHaveUserData();
        }
    });
}

// if ( sessionStorage.getItem(window.storageKey) ) {
//   // already have data from previous page load
//   onHaveUserData();
// } else {
//   // fetch user info
// }
fetchUserData();

// $('body').on('updated_cart_totals wc_cart_emptied', function () {
//     sessionStorage.removeItem(window.storageKey);
//     fetchUserData();
// });
